import React from "react";
import ReactApexChart from "react-apexcharts";
import { Form, InputGroup } from "react-bootstrap";
import { CancelButton, SaveButton } from "../../../common/Button";

function ProductPieChart({ productData, productCount }) {
  class ApexChart extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        series: productCount,
        options: {
          chart: {
            type: "pie",
            height: 350,
          },

          labels: productData,

          legend: {
            position: "right",
            fontSize: "12px",
            itemMargin: {
              vertical: 6,
            },
            formatter: function (seriesName) {
              // wrap long text
              return `<span style="white-space: normal; max-width: 180px; display: inline-block;">
                ${seriesName}
              </span>`;
            },
          },

          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return `${val.toFixed(1)}%`;
            },
          },

          responsive: [
            {
              breakpoint: 768,
              options: {
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      };
    }

    render() {
      return (
        <div
          style={{
            maxWidth: "100%",
            margin: "0 auto",
            padding: "10px",
            borderRadius: "5px",
            boxShadow: "0px 0px 5px #29292980",
          }}
        >
         
          <ReactApexChart
            options={this.state.options}
            series={this.state.series}
            type="pie"
            height={350}
          />
        </div>
      );
    }
  }

  return <ApexChart />;
}

export default ProductPieChart;
